import script from "./PageOne.vue?vue&type=script&setup=true&lang=js"
export * from "./PageOne.vue?vue&type=script&setup=true&lang=js"

import "./PageOne.vue?vue&type=style&index=0&id=73c5edba&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c5edba"]])

export default __exports__